import {
  PaymentDetailContainer, PaymentDetailText, PaymentDetailItem, PaymentDetailSubtitle, PaymentDetailColumn
} from "views/PaymentFlow/Summary/SubscriptionDetail/SubscriptionDetail.styles";

interface PaymentDetailProps {
  detail: BenevPaymentDetail
}

function SubscripbtionDetail(props: PaymentDetailProps) {
  const {detail} = props;
  return (
    <PaymentDetailContainer>
      <PaymentDetailText>{detail.paymentDetail}</PaymentDetailText>

      <PaymentDetailColumn>
        <PaymentDetailItem>{detail.paymentItem}</PaymentDetailItem>
        <PaymentDetailSubtitle>{detail.paymentSubtitle}</PaymentDetailSubtitle>
      </PaymentDetailColumn>
    </PaymentDetailContainer>
  )
}

export default SubscripbtionDetail;
